<script setup>
defineProps({
  as: {
    type: [Object, String],
    default: 'button',
  },
  square: {
    type: Boolean,
    default: false,
  },
  insetFocus: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <component
    :is="as"
    :class="[{ rounded: !square }, insetFocus ? 'focus:ring-inset' : 'focus:ring-offset-2']"
    class="inline-flex items-center border border-gray-300 bg-white px-3 py-2 font-bold text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-blue-light disabled:cursor-default disabled:opacity-50 disabled:hover:bg-white">
    <slot />
  </component>
</template>
